module.exports = __webpack_public_path__ + "img/RJC_LP_nachhaltigkeit.19844e4.webp";